import React from "react";
import { Dialog } from "@headlessui/react";
import CLOSE from "../../../../assets/images/icons/close.svg";
import SingleAccount from "./singleAccount";

export default function FormSection3({ formWizardRef, props }) {
  return (
    <Dialog.Panel className="relative sm:w-[600px] h-[877px] bg-white dark:bg-[#010101] rounded-3xl px-4 pt-5 pb-4 text-left overflow-y-scroll shadow-xl transform transition-all sm:my-8  w-full sm:p-8">
      <div className=" sm:block absolute top-2 right-2 pt-4 pr-4">
        <button
          type="button"
          className="bg-[#ffeae5] rounded-md p-2 sm:p-3 "
          onClick={props.onClose}
        >
          <span className="sr-only">Close</span>
          <img src={CLOSE} alt="close" className=" w-3 h-3 sm:w-4 sm:h-4" />
        </button>
      </div>
      <div className="sm:flex sm:items-start">
        <div className="mt-16 md:mt-20 sm:mt-10 text-left max-w-[358px]">
          <Dialog.Title
            as="h3"
            className="text-2xl font-bold text-black dark:text-white"
          >
            Choose Account
          </Dialog.Title>
          <div className="mt-2">
            <p className="text-sm font-normal text-gray-500">
              Looks like you have access to multiple accounts, choose from the
              option below to continue.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-16 sm:mt-8">
        <SingleAccount formWizardRef={formWizardRef} />
      </div>
    </Dialog.Panel>
  );
}
